import React, { useContext } from 'react'
import { Button, Container, Col, Row, Card } from 'react-bootstrap'
import { DefaultSpinner } from '../pageBlocks/Spinners'
import httpClient from '../../services/httpClient'
import appConfig from '../../app.config'
import { useTranslation } from 'react-i18next'
import SigningContext from '../../contexts/SigningContext'
import { appInsights } from '../../appInsights'
import { SmartIdInteractionTypes } from '../../interfaces/i-smart-id-interaction'
import { documentTypes } from '../../constants/documentTypes'
import axios from 'axios'

function SmartIdAdvSignBlock() {
	const [isWaiting, setIsWaiting] = React.useState(false)
	const [code, setVerificationCode] = React.useState('')
	const { t } = useTranslation()
	const { signingRequest, setSigned, setError } = useContext(SigningContext)

	const id = signingRequest?.id ?? ''

	async function doSmartIdSign() {
		setError(undefined)

		setIsWaiting(true)

		try {
			const userCountry = appConfig.country
			const signInitiate = await httpClient.smartIdSignInitiate({
				country: userCountry || '',
				signingRequestId: id,
			})
			const verification = signInitiate.verificationCode
			setVerificationCode(verification)
			setIsWaiting(false)

			//wait for 1 second before calling complete endpoint in order to leave the customers enaugh time to memorize the code
			await new Promise((resolve) => setTimeout(resolve, 1000))

			await httpClient.smartIdSignComplete({
				verificationCode: verification || '',
				signatureValue: signInitiate.signatureValue || '',
				signingRequestId: id,
				containerId: signInitiate.containerID || '',
				allowedInteractionOrder: [
					{
						type: SmartIdInteractionTypes.CONFIRMATION_MESSAGE_AND_VERIFICATION_CODE_CHOICE,
						displayText200: getDisplayText(),
					},
				],
			})
			setSigned()
		} catch (exception) {
			const error = exception as Error
			setVerificationCode('')
			appInsights.trackException({ exception: error })
			if (axios.isAxiosError(error) && error.response?.status === 400) {
				const { errorCode } = error.response.data as {
					errorCode: string
				}
				setError(
					new Error(
						t(
							`SmartIdSignError_${errorCode}`,
							t('AuthenticationError'),
						),
					),
				)
			} else {
				setError(error)
			}
		}

		setIsWaiting(false)
	}

	function getDisplayText() {
		let messageKey =
			'SmartIdPNDisplayText200' + appConfig.country.toUpperCase()
		if (
			appConfig.country === 'lt' &&
			signingRequest?.documentType !== documentTypes.promissoryNote
		) {
			messageKey = 'SmartIdConsentDisplayText200'
		}

		return t(messageKey)
	}

	if (isWaiting) {
		return (
			<Container>
				<Col>
					<DefaultSpinner />
				</Col>
			</Container>
		)
	}

	if (code) {
		return (
			<Container>
				<Card>
					<Card.Body className="verification-container">
						<Row className="mx-auto">
							<h4>{t('Verification code')}</h4>
							<h1>{code}</h1>
						</Row>
						<DefaultSpinner />
					</Card.Body>
					<Card.Footer>
						<Row className="notification">
							<div className="col-1 glyphicon glyphicon-info-sign"></div>
							<div className="col-11">
								{t(
									'Notification sent to your smart device. Verify the code in the Smart-ID app and enter PIN2',
								)}
							</div>
						</Row>
					</Card.Footer>
				</Card>
			</Container>
		)
	}

	return (
		<Container>
			<Row>
				<Container>
					<div>
						<p>
							{t(
								'Please click the proceed button to sign the document',
							)}
						</p>
					</div>
				</Container>
			</Row>
			<Row className="mt-2">
				<Button variant="primary" onClick={doSmartIdSign}>
					{t('Proceed')}
				</Button>
			</Row>
		</Container>
	)
}

export default SmartIdAdvSignBlock
